import React, { useEffect, useContext } from 'react';
// import PropTypes from "prop-types";
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { AgGrid, filters, filterParams } from '../../AgGrid';
// import { DynamicForm, DynamicFormModal } from "../../DynamicForm";
// import * as v from "../../../helpers/validation";
import { OrderDetailContext } from '../OrderDetailContext';
import { format } from 'date-fns';

// SERVICES
import { getOrderActivityHistory } from '../../../services';

const styles = theme => ({});

export const OrderDetailHistoryTab = withStyles(styles)(props => {
  const {
    state: { history },
    dispatch,
  } = useContext(OrderDetailContext);
  const { orderLineId } = props;

  // const [historyData, setHistoryData] = useState([]);

  const historyColDefs = [
    { headerName: 'Service Type', field: 'serviceType', filter: 'set' },
    { headerName: 'Action', field: 'action', filter: 'set' },
    { headerName: 'Before', field: 'beforeStep' },
    { headerName: 'After', field: 'afterStep' },
    { headerName: 'Assigned to User', field: 'assignedToUser' },
    { headerName: 'Modified On', field: 'changeDateTime', cellRenderer: 'dateUTC' },
    { headerName: 'Modified By', field: 'modifiedBy' },
  ];

  const getOrderActivityHistoryAsync = async () => {
    try {
      const res = await getOrderActivityHistory(orderLineId);
      console.log(res);
      // setHistoryData(res);
      dispatch({
        type: 'UPDATE_HISTORY',
        history: res,
      });
    } catch (error) {
      // setHistoryData([])
      console.log(error);
    }
  };

  useEffect(() => {
    if (!history) {
      getOrderActivityHistoryAsync();
      // updateLoaded(true);
    }
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridName="ORDER_DETAIL_HISTORY"
        gridData={history}
        columnDefs={historyColDefs}
        redirectOnClick={false}
        editOnClick={false}
        extraGridProps={{
          groupDefaultExpanded: 1,
        }}
      />
    </div>
  );
});

OrderDetailHistoryTab.propTypes = {};

OrderDetailHistoryTab.defaultProps = {};
